export const SET_ORDEN = "SET_ORDEN";
export const NEW_ORDEN = "NEW_ORDEN";
export const ADD_ITEM = "ADD_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const UPDATE_ITEM = "UPDATE_ITEM";
